<!-- 控销-图文海报审核（卖家端发布的图文海报） promotionAuditOps -->
<template>
  <div class="classification">
    <div class="header">
      <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left">
        <el-form-item prop="nameLike" label="">
          <el-input v-model.trim="formTool.posterName" placeholder="请输入海报名称" clearable size="small" />
        </el-form-item>

        <el-form-item prop="extendType" label="审核状态">
          <el-select v-model="formTool.checkStatus" clearable style="width: 120px;" size="small" placeholder="类别">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset()">重置</el-button>
        </el-form-item> 
      </el-form> 
    </div>

    <div class="center" style="position: relative">
      <MyTable :table-data="tableData" :index="index" :selection="selection" :page="page" :operation="operation"
        :table-option.sync="tableOption" @page-change="getList" @handleSelectionChange="handleSelectionChange"> 
        <template slot="menu" slot-scope="scope" >
          <el-link :underline="false" type="primary" @click="detailHandle(scope.row)"
          
              class="btn-list">审核</el-link>  
        </template> 
        <template slot="checkStatus" slot-scope="scope"> 
          <span style="color:#E6A23C"  v-if="scope.row.checkStatus == 0 "><i class="el-icon-warning"></i> 待审核</span>  
          <span style="color:#67C23A" v-if="scope.row.checkStatus == 1"><i class="el-icon-success" ></i> 审核通过</span> 
          <span style="color:#F5222d"  v-if="scope.row.checkStatus == 2 "><i class="el-icon-warning"></i> 审核驳回</span>  
        </template>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]" layout="sizes, prev, pager, next" :total="page.total">
        </el-pagination>

      </MyTable>
    </div>

    <addDialog ref="add-dialog" @getList="getList" @reject="reject"/>
    <rejectDialog ref="reject-dialog" @getList="getList" />
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import addDialog from "./components/add.vue";
import rejectDialog from "./components/rejectDialog.vue";
import { mapGetters } from 'vuex'

import { salesPosterInfoPage } from "@/api/externalSalesRule";

import avater from "/public/img/default.png";
export default {
  components: { MyTable, addDialog,rejectDialog },
  data() {
    return {
      avater: avater,
      formTool: {
        name: "",
      },
      btnType: 'add',
      selectionList: [],
      operation: true,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [
        { label: "海报ID", prop: "posterId" },
        { label: "海报名称", prop: "posterName" }, 
        { label: "审核状态", prop: "checkStatus", slot: true },
        { label: "创建时间", prop: "createTime" }, 
      ],
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      options: [
      {
          value: '0',
          label: '待审核'
        },
        {
          value: '1',
          label: '审核通过'
        },
        {
          value: '2',
          label: '审核驳回'
        },
      ],
      dialogShow: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.salesPosterInfoPage();
  },
  mounted() { },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
   
    // 页码变化
    handleCurrentChange(e) {
      this.page.current = e
    },
    // 条数变化
    handleSizeChange(e) {
      this.page.size = e
      this.page.current = 1
    },

    detailHandle(row, btnType) {
      if(row.checkStatus != 0 ){
         this.$refs['add-dialog'].init(row, 'detail') 
      }else{
        this.$refs['add-dialog'].init(row) 
      }
    },

    reject(id){  
      console.log(id) 
      this.$refs['reject-dialog'].init(id);
    },
   
    // 重置查询条件
    reset() {
      this.formTool = {};
      this.getList(1);
    },
    // 搜索
    getList(current) {
      this.salesPosterInfoPage(current);
    },
    // 勾选
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 查询 
    salesPosterInfoPage(current) {
      if (current) { 
        this.page.current = current;
      }
      if (this.formTool.name == "") {
        delete this.formTool.name;
      }
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size 
      };
      params.clientTag='ops';
      // @Parameter(name = "clientTag",description = "客户端标识（app：app端，sell:卖家端, ops：ops端）"),
      salesPosterInfoPage(params).then((res) => {
        if (res.records) {
          this.tableData = res.records;
          this.page.total = res.total;
          this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";

.classification {
  padding: 0px;

  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .top {
    display: flex;
    padding: 10px 0 10px 0;

    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        width: 120px;
      }

      .button {
        margin-right: 20px;

        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;

          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around; 
    
  }
}
</style>
